import React, { MouseEvent, ReactElement } from 'react';
import classcat from 'classcat';
import { EIconSize } from 'utils/constants/app/ui';
import { GlobalIcon } from 'components/GlobalIcon';
import './index.less';

type Props = {
  arrow?: '' | 'horizontal' | 'down' | 'up' | 'empty';
  onClick?: (event: MouseEvent) => void;
  children: React.ReactNode;
  thumb?: React.ReactNode;
  extra?: React.ReactNode;
  disabled?: boolean;
  active?: boolean;
  noNeedClass?: boolean;
  dataTestId?: string;
  arrowDataTestId?: string;
};

export const ListItem = ({
  children,
  thumb,
  extra,
  disabled,
  arrow,
  onClick,
  active,
  noNeedClass,
  dataTestId,
  arrowDataTestId
}: Props): ReactElement => {
  return (
    <div
      {...(dataTestId ? { 'data-testid': dataTestId } : {})}
      className={classcat(['listItem', { 'listItem--active': active }])}
      onClick={onClick}
    >
      {thumb && (
        <div className={noNeedClass ? '' : 'listItem__thumb'}>{thumb}</div>
      )}
      <div className="listItem__name">{children}</div>
      {extra && <div className="listItem__extra">{extra}</div>}
      {arrow === 'horizontal' && !disabled && (
        <GlobalIcon
          lib="generic"
          name="caretRight"
          theme="default"
          size={EIconSize._11}
          className="listItem__arrow"
          useWrapper
          {...(arrowDataTestId ? { 'data-testid': arrowDataTestId } : {})}
        />
      )}
    </div>
  );
};
